import CarouselAbstr, { CarouselOptions } from '../CarouselAbstr';
import Slide from '../Slide';

export default class featureCarousel extends CarouselAbstr {
	constructor(options: CarouselOptions) {
		super(options);
		this.init();
	}

	protected init(): void {
		const slidesColl = this.carouselEl.getElementsByClassName('featureCarousel__slide');
		for (let i = 0; i < slidesColl.length; i++) {
			const element = slidesColl[i];
			const isActive = i === 0;
			this.slides.push(new Slide({ element, isActive }));
		}

		/* this.slides.forEach((slide, index) => {
			this.buildIndicators(index);
		}); */
		
		this.initAutoAdvance();
		/* const controlPrev = this.carouselEl.querySelectorAll('.slide--prev');
		const controlNext = this.carouselEl.querySelectorAll('.slide--next');

		for (let i = 0; i < controlPrev.length; i++) {
			controlPrev[i].addEventListener('click', (event: MouseEvent) => {
				this.activatePrevIndex();
				this.trackControlEvent(this.eventLabels.previous);
			});
		}

		for (let i = 0; i < controlNext.length; i++) {
			controlNext[i].addEventListener('click', (event: MouseEvent) => {
				this.activateNextIndex();
				this.trackControlEvent(this.eventLabels.next);
			});
		} */
	}
}
